import Filter from "./Filter";
import { MenuDotBold, OutlineProfile2User } from "../Icon";
import Config from "./Config-dropdown";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import { Row, Col } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { forwardRef, useEffect, useState } from "react";
import { getUserList } from "../../apis/apiUsers";
import Icon from "../Icon/Icon";
import { MCButton } from "../MainComponents/Button/Button";
import { Breadcrum } from "../MainComponents/Breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";
import { MCTooltip } from "../MainComponents/Tooltip/Tooltip";
import SearchBar from "../../components/SearchBar/Search";
import {
  Box,
  CardMedia,
  Tooltip,
  useTheme,
  Stack,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableContainer,
} from "@mui/material";
import { EGPageHeader } from "../Title/PageHeader/EGPageHeader";
import Etiquin from "../../assets/images/Ethiquin/ethiquin_no_data.svg";
import { EGPaginator } from "../Paginator/Paginator";

export const Users = () => {
  const theme = useTheme();
  const [t] = useTranslation("users");
  const navigate = useNavigate();
  // Columns in Users Table
  const initialColumns = [
    {
      id: "nombre",
      name: t("Users.name"),
      checked: true,
      // selector: (row) => (row.first_name && row.first_name ? row.first_name : t("Users.unregistered")),
      selector: (row) =>
        {
          const name = row.first_name || "";
          const lastName = row.last_name || "";
          const fullName = `${name} ${lastName}`.trim();
          return fullName || t("Users.unregistered");
        }
    },
    // {
    //   id: "número_de_ingresos",
    //   name: "Número de ingresos",
    //   checked: true,
    //   selector: (row) =>
    //     row.date_joined ? row.date_joined : "No hay fecha de ingreso",
    // },
    // { id: "bloqueado", name: "Bloqueado", checked: false },
    {
      id: "email",
      name: "Email",
      checked: true,
      selector: (row) =>
        (row.email && row.email ? row.email : t("Users.no_data")),
    },
    // {
    //   id: "usuario_ethicsglobal",
    //   name: t("User.user_ethicsglobal"),
    //   checked: true,
    //   selector: (row) =>
    //     row.username ? row.username : t("Users.no_username"),
    // },
    // {
    //   id: "relación_con_la_empresa",
    //   name: t("Users.company_relationship"),
    //   checked: false,
    // },
    // {
    //   id: "apellidos",
    //   name: t("Users.lastname"),
    //   checked: true,
    //   selector: (row) => (row.last_name ? row.last_name : t("Users.unregistered")),
    // },
    // {
    //   id: "líder",
    //   name: t("Users.leader"),
    //   checked: true,
    //   selector: (row) => (row.is_staff ? row.is_staff : t("Users.no_assigned_leader")),
    // },
    // { id: "tipo_de_reporte", name: t("Users.report_type"), checked: false },
    {
      id: "rol",
      name: t("Users.role"),
      checked: true,
      selector: (row) => (row.role ? row.role : t("Users.no_role_assigned")),
    },
    // {id: "temporal", name: t("Users.temporary"), checked: false},
    // {id: "entrada actual", name: t("Users.current_entry"), checked: false},
    {
      id: "activo",
      name: t("Users.active"),
      checked: true,
      selector: (row) =>
        row.is_active === true
          ? t("Users.yes")
          : "No"
    },
  ];

  // const BootyCheckbox = forwardRef(({ onClick, ...rest }, ref) => (
  //   <div className="form-check">
  //     <input
  //       htmlFor="booty-check"
  //       type="checkbox"
  //       className="form-check-input"
  //       ref={ref}
  //       onClick={onClick}
  //       {...rest}
  //     />
  //     <label className="form-check-label" id="booty-check" />
  //   </div>
  // ));

  // States
  const [listUser, setListUser] = useState([]);
  const [checks, setChecks] = useState(
    initialColumns.map((item) => ({
      id: item.id,
      name: item.name,
      checked: item.checked,
    }))
  );
  const [columns, setColumns] = useState(initialColumns);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  }

  const applyConfig = () => {
    const columnsFinal = [];
    checks.map((item1) => {
      if (item1.checked) {
        const column = initialColumns.find((item2) => item1.id === item2.id);
        columnsFinal.push(column);
      }
    });
    columnsFinal.push({
      id: "actions",
      name: t("Users.actions"),
      label: t("Users.actions"),
      checked: true,
    });
    setColumns(columnsFinal);
  };

  const [filtredActiveUsers, setFiltredActiveUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [allUsers, setAllUsers] = useState([]);

  const handleSearch = (value) => {
    setSearch(value);

    if (value.trim() === "") {
      setFiltredActiveUsers(allUsers); // Si la búsqueda está vacía, mostrar todos los usuarios
      setListUser(allUsers);
      return;
    }

    const cleanedSearch = value.trim().toLowerCase();
    const filtredUsersTemp = allUsers.filter((user) => {
      const firstNameLowerCase = user.first_name.toLowerCase();
      const emailLowerCase = user.email.toLowerCase();
      return (
        firstNameLowerCase.includes(cleanedSearch) ||
        emailLowerCase.includes(cleanedSearch)
      );
    });

    setFiltredActiveUsers(filtredUsersTemp);
    setListUser(filtredUsersTemp);
    setTotalCount(filtredUsersTemp.length);
    setPage(1);
  };

  useEffect(() => {
    applyConfig();
    getUserList()
      .then((resp) => {
        const users = resp.users  || [];
        setAllUsers(users);
        setFiltredActiveUsers(users);
        setListUser(users);
        setTotalCount(users.length);
        setListUser(resp.users);
      })
      .catch((error) => enqueueSnackbar(error.message, { variant: "error" }));
  }, []);

  return (
    <Box id="settings" className={`users-page`}>
      <Box className="dyTheme1 dyBorder1 general-header"
      sx={{
        p: { xs: 1.5, lg: '10px 20px' },
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'flex-start', lg: 'center' },
        justifyContent: 'space-between',
        gap: { xs: 2, lg: 0}
      }}>
          <Box sx={{ flexGrow: 1 }}>
            <EGPageHeader
                      breadcrumbItems={[
                        { label: t("Users.home"), route: "/" },
                        { label: t("Users.all_users") },
                      ]}
                      title={t("Users.all_users")}
                      subtitle={t("Users.customize_user_roles_permissions")}
                      mainIconName="outline_profile_2_user"
                    />
          </Box>

          <Box
            sx={{
              flex: { md: 1 },
              display: 'flex',
              justifyContent: { xs: 'center', md: 'flex-end' },
              width: { xs: '100%', md: 'auto' },
              order: { xs: 3, md: 3 }
          }}
          >
            {/* <Config
              applyConfig={applyConfig}
              checks={checks}
              setChecks={setChecks}
            /> */}
              <MCButton
                icon="outline_user_add"
                label={t("Users.add_user")}
                variant="primary"
                size="sm"
                onClick={() => navigate("/users/new")}
              />
          </Box>
      </Box>

        {/* Title - SearchBar */}
      <Box className="dyTheme1 dyBorder1"
      sx={{
        borderRadius: 2,
        p: { xs: 1, sm: 2.5 },
        mt: 2.5,
      }}>
        <Box sx={{ mb: 3}}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              bgcolor: theme.palette.background.paper,
              border: `${theme.palette.blueGray100.main} 1px solid`,
              py: { xs: 1, sm: 1.5 },
              px: { xs: 1.5, sm: 2 },
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              gap: 2,
            }}
            >

            <Typography variant="h6" color="secondary">
              {t("Users.registered_users_list")}
            </Typography>

            <Box sx={{
              display: 'flex',
              flexDirection: { xs:'column', sm: 'row' },
              justifyContent: { xs: 'center', md: 'flex-end' },
              alignItems: 'center',
              gap: 1,
              width: { xs: '100%', md: '60%', lg: '50%'},
              marginLeft: 'auto'
            }}>
              <SearchBar
                placeholder={t("Users.enter_user")}
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </Box>
          </Box>
        </Box>

            {/* Table Content */}
        <Box
        sx={{
          mt: -0.3,
          pt: { xs: 1, sm: 1.5 },
          borderBottomLeftRadius: 8,
          borderBottomRightRadius: 8,
        }}
        className="dyTheme1"
        >
          {listUser.length > 0 ? (
          <Box>
          <TableContainer
            sx={{
              height: "60vh",
              overflowY: "auto",
              borderTopLeftRadius: "6px",
              borderTopRightRadius: "6px",
            }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {/* title head */}
                {columns.map((column, idx) => (
                  <TableCell
                    key={column.id}
                    sx={{
                      minWidth: column.mW,
                      py: 1.5,
                      paddingInlineStart: 3,
                      align: "center",
                      fontWeight: "bold",
                      backgroundColor: theme.palette.blueGray50.main,
                    }}
                  >
                    <Typography variant="subtitle2">{column.name}</Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

          <TableBody>
            {listUser
            .slice((page -1) * rowsPerPage, (page -1) * rowsPerPage + rowsPerPage)
            .map((user) => {
              const actionsColumn = columns.find(c => c.id === "actions");
              return(
                <TableRow
                  key={user.id}
                  hover
                  sx={{
                    cursor: "pointer",
                    transition: "transform 0.2s ease-in-out",
                    transformOrigin: "center",
                  }}
                  >

                  {/* contenido dinámico (datos de la tabla)  */}
              {columns.filter(c => c.id !== "actions").map((column) =>
                <TableCell key={column.id} align="center"
                sx={{
                  fontSize: 12,
                  py: 2,
                  px: 1.5
                }}>
                  <Typography
                    variant="body2"
                    fontSize={13}
                    textAlign={{ xs: "left", md: "left" }}
                    >
                  {column.selector(user)}
                  </Typography>
                </TableCell>
              )}

              {actionsColumn && (
                <TableCell key="actions">
                  <Stack
                    direction="row"
                    spacing={0.5}
                    justifyContent={"start"}
                  >
                    <Tooltip title={t("Users.edit_user")} arrow placement="bottom">
                      <Box
                        onClick={() => navigate(`/users/edit/${user.id}`, { state: { user } })}
                      >
                        <Icon name="outline_user_edit" />
                      </Box>
                    </Tooltip>
                    <Tooltip
                      title={t("Users.build_user_segment")}
                      arrow
                      placement="bottom"
                    >
                      <Box
                        onClick={() =>
                          navigate(`users/segments/new/`, { state: { user } })
                        }
                      >
                        <Icon name="outline_shield" />
                      </Box>
                    </Tooltip>
                  </Stack>
                </TableCell>
                )}
            </TableRow>
            );
            })}
            </TableBody>
          </Table>
          </TableContainer>
          <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
            px: 2,
            py: 1.5,
            borderTop: `1px solid ${theme.palette.divider}`,
            minHeight: '60px',
          }}>
          <Stack sx={{ flexFlow: "row nowrap" }}>
                  <Typography p={0.5} fontSize={11}>
                    {t("Users.per_page")}:
                  </Typography>
                  <select
                    className="paginator__select"
                    name="limit"
                    value={rowsPerPage}
                    onChange={handleChangeRowsPerPage}
                  >
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                  </select>
            </Stack>

            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ mt: 2, mb: 1 }}
            >
              <EGPaginator
                count={Math.ceil(totalCount / rowsPerPage)}
                page={page}
                onChange={handleChangePage}
              />
            </Stack>

            <Typography p={0.5} fontSize={12} sx={{
                minWidth: { md: "200px" },
                textAlign: { xs: "center", md: "right" },
            }}>
              {`${t("Users.results")}: ${
              totalCount === 0 ? 0 : (page - 1) * rowsPerPage + 1
              } ${t("Users.to")} ${Math.min(
                page * rowsPerPage,
                totalCount
              )} ${t("Users.of")} ${totalCount}`}
            </Typography>
            </Box>
          </Box>
          ) : (
            <Stack
            sx={{
              height: "50vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CardMedia
              component="img"
              image={Etiquin}
              alt="not_found"
              sx={{ height: "45%", width: "45%", objectFit: "contain" }}
            />
            <Typography
              variant="h5"
              textAlign="center"
              color="secondary"
              mt={1.5}
            >
              {t("Users.no_results_found")}...
            </Typography>
          </Stack>
          )}
        </Box>
      </Box>
    </Box>
  );
};
